// removed by extract-text-webpack-plugin
module.exports = {"dataCube":"data-cube-module__dataCube___R6CFr","dataCubeFullHeight":"data-cube-module__dataCubeFullHeight___QN1d-","dataCubeNoMargin":"data-cube-module__dataCubeNoMargin___z75NV","dataCubeTop":"data-cube-module__dataCubeTop___3uONa","dataCubeBottom":"data-cube-module__dataCubeBottom____jBkg","dataCubeHeading":"data-cube-module__dataCubeHeading___3K_UH","dataCubeValue":"data-cube-module__dataCubeValue___2owKt","dataCubeButton":"data-cube-module__dataCubeButton___2AePg","dataCubeButtonChevron":"data-cube-module__dataCubeButtonChevron___2Lk_b","dataCubeText":"data-cube-module__dataCubeText___LN_qK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/data-cube/data-cube.module.scss
// module id = 876
// module chunks = 0 1